// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__l0hkw","field":"styles_field__1AfLO","fieldCol":"styles_fieldCol__3ZPH-","diffCol":"styles_diffCol__2NRCh","diff":"styles_diff__kQc4N"};